import React, { useRef } from "react"
import { useFrame, useLoader } from "@react-three/fiber"
import { Vector3 } from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import textures from 'constants/models/mappingTextures.json'
// import { useTweaks } from "use-tweaks"
// Convenience hook that selects a KHR material variant

/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
export default function Model3D(props) {
    // Fetch model
    const ref = useRef();
    const { nodes, userData, parser } = useLoader(GLTFLoader, props.path || "/male_integumentary_system.glb", (loader) => {
        loader.setPath("assets/models");
    })
    // Create a GUI tweak panel
    //   const { colorway } = useTweaks({
    //     colorway: {
    //       value: 0,
    //       options: userData.gltfExtensions.KHR_materials_variants.variants
    //         .map((variant) => variant.name)
    //         .reduce((acc, name, index) => ({ ...acc, [name]: index }), {}),
    //     },
    //   })
    //   // Apply mapping
    //   useVariant(colorway, ref, parser)
    // Animate model
    useFrame((state) => {
        // switch (props.mode?.id) {
        //     case (2): {
        //         ref.current.rotation.y = ref.current.rotation.y + 0.005;
        //         break;
        //     }
        //     default: {

        //         ref.current.rotation.y = ref.current.rotation.y + 0.005;
        //     }
        // }
    })
    // console.log('nodes', props.path, Object.values(nodes).filter(e => !!e.material).map(e => {
    //     return { system: props.path, name: e.name, materialName: e.material?.name }
    // }))
    const position = props.genre === 'male' ? new Vector3(0, -0.8, 1.1) : new Vector3(0, -0.8, 0);
    const scale = props.genre === 'male' ? new Vector3(0.002, 0.002, 0.002) : new Vector3(0.02, 0.02, 0.02);

    console.log(props.removedParts)

    return (
        Object.values(nodes).filter(e => e.name !== 'inputobj').map((item, index) => {
            const textureJson = textures.find(e => e.name === item.name && e.system.startsWith('/' + props.genre));
            const config = {
                metalness: 0.5,
                roughness: 0.1,
                color: textureJson?.colorCustom || textureJson?.color || props.color,
                opacity: textureJson?.opacity || props.opacity || 0.5,
                color: 'black',
            }
            switch (item.name) {
                default: {
                      config.color = props.color || 'rgb(201, 224, 255)';
                }
            }
            return (
                <mesh ref={ref} key={index} geometry={item.geometry} position={position} scale={scale} userData={item.userData} >
                    {
                        <meshStandardMaterial
                            attach="material"
                            {...config}
                            //   opacity={0.5}
                            transparent={true}
                            visible={!(props.removedParts || []).includes(item.name)}
                        />
                    }
                </mesh>
            )
        })
    )
}
